import { REQUEST_MAPPING } from "@/common/constant";
import REQUEST from "@/common/api.service";

export const LOGIN = ({ username, password }) =>
  REQUEST.post(REQUEST_MAPPING.AUTH_V1.concat("/login"), {
    username,
    password,
  });

export const LOGOUT = () =>
  REQUEST.get(REQUEST_MAPPING.AUTH_V1.concat("/logout"));

export const GET_ROLE = () =>
  REQUEST.get(REQUEST_MAPPING.AUTH_V1 + "/get-role");

export const RESET_PASS = (params) =>
  REQUEST.post(REQUEST_MAPPING.USER + "/change-password", params);
